const host = () => {
  return process.env.host
}

export default (_, inject) => {
  inject('host', host)
}
